import {
  getListApi,
  getProgressApi,
  getFeedbackApi,
  getFeedbackApiV1,
  getDetailApi,
  getAllFeedbackApi,
  getMiscellaneousFeedbackApi,
  getListV1Api,
  getAllStatsApi,
  getCompetencyStatsApi,
} from 'api/developments';
import HashTag from 'models/hashtag';
import Post from 'models/post';

import { COMPETENCY_SIDEPANEL_TYPE, MISCELLANEOUS_COMPETENCY_ID } from 'constants/ProjectConstants';

export function getList({ employeeId, teamId, tagType, pageType }) {
  return getListApi({ employeeId, teamId, tagType, pageType }).then((res) =>
    res.entity.map((json) => {
      const tag = new HashTag();
      tag.fromJSON(json.orgTag);
      tag.addStatsFromJSON(json.stats);
      return tag;
    })
  );
}

export function getDetail({ employeeId, employeeMappingId, pageType = COMPETENCY_SIDEPANEL_TYPE.HOME_PAGE }) {
  const empMappingId = employeeMappingId === MISCELLANEOUS_COMPETENCY_ID ? null : employeeMappingId;
  return getDetailApi({ employeeId, employeeMappingId: empMappingId, pageType }).then((res) => {
    const tag = new HashTag();
    if (!res.entity) return null;
    tag.fromJSON(res.entity.orgTag);
    tag.addStatsFromJSON(res.entity.stats);
    return tag;
  });
}

export function getProgress({ employeeId }) {
  return getProgressApi({ employeeId }).then((res) => res.entity);
}

export function getFeedback({ employeeId, limit, offset, type, tagId }) {
  const competancyTagId = MISCELLANEOUS_COMPETENCY_ID === tagId ? null : tagId;
  return getFeedbackApi({ employeeId, limit, offset, type, tagId: competancyTagId }).then((res) =>
    parseFeedbackRes(res.entity)
  );
}

function parseFeedbackRes(res) {
  return res.map((data) => Post.fromJSON(data.post));
}

export function getFeedbackV1({ employeeId, limit = 8, offset = 0, tagId, feedbackType }) {
  return getFeedbackApiV1({ employeeId, limit, offset, feedbackType, tagId }).then((res) =>
    parseFeedbackRes(res.entity)
  );
}

export function getAllFeedback({ employeeId, limit, offset, feedbackType }) {
  return getAllFeedbackApi({ employeeId, limit, offset, feedbackType }).then((res) => parseFeedbackRes(res.entity));
}

export function getMiscellaneousFeedback({ employeeId, limit, offset, feedbackType }) {
  return getMiscellaneousFeedbackApi({ employeeId, limit, offset, feedbackType }).then((res) =>
    parseFeedbackRes(res.entity)
  );
}

// performance review infobar strengths updated api.
// Didn't know where to place it for better organisation

export function getListV1({ employeeId, teamId, tagType, includeMiscellaneous = false }) {
  return getListV1Api({ employeeId, teamId, tagType, includeMiscellaneous }).then((res) =>
    res.entity.map((json) => {
      const tag = new HashTag();
      tag.fromJSON(json.orgTag);
      tag.addStatsFromJSON(json.stats);
      return tag;
    })
  );
}

export function getAllStats({ employeeId }) {
  return getAllStatsApi({ employeeId }).then((res) => {
    const tag = new HashTag();
    if (!res.entity) return null;
    tag.fromJSON({});
    tag.stats = {
      appreciativeFeedbackCount: res.entity.appreciativeFeedbackCount || 0,
      constructiveFeedbackCount: res.entity.constructiveFeedbackCount || 0,
    };
    return tag;
  });
}

export function getCompetencyStats({ employeeId, competencyId }) {
  return getCompetencyStatsApi({ employeeId, competencyId }).then((res) => {
    const tag = new HashTag();
    if (!res.entity) return null;
    tag.fromJSON(res.entity.orgTag);
    tag.addStatsFromJSON(res.entity.stats);
    return tag;
  });
}
